import { render, staticRenderFns } from "./assignPageFunction.vue?vue&type=template&id=5dfbf543&lang=pug&"
import script from "./assignPageFunction.vue?vue&type=script&lang=js&"
export * from "./assignPageFunction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports